<template>
  <PopupBackground @click="toggleGridLookupPopup">
    <div class="lookup-card" @click.stop>
      <!-- Header -->
      <div class="header">
        <div class="title">
          <h3>{{ `Grid Id: ${getActiveGrid || "Blah blah Blah"}` }}</h3>
          <p>All the entities present inside the grid</p>
        </div>
      </div>
      <!-- contents -->
      <div class="contents">
        <simplebar
          v-if="!isLoading && isDataAvailable"
          :class="[
            'grid-entity-list',
            { 'disable-events': getConfig.isPublicView },
          ]"
          data-simplebar-auto-hide="true"
        >
          <router-link
            v-for="(entity, index) in mapEntityidToName"
            :class="[{ 'disable-events': getConfig.isPublicView }]"
            :key="index"
            :to="`/overview/${entity.entity_id}/${entity.id}`"
            target="_blank"
          >
            <div class="lookup-entity-item">
              <icon class="entity-icon">device_hub</icon>
              <div class="flex-col flex-expand">
                <label>{{ entity.entity_name }}</label>
                <h4>{{ entity.id }}</h4>
              </div>
              <icon class="launch-icon">launch</icon>
            </div>
          </router-link>
        </simplebar>
        <LoadingBar v-if="isLoading" />
        <p class="help-text" v-if="!isDataAvailable && !isLoading">
          Sorry, Unable to find data for the grid
        </p>
      </div>
      <!-- Footer -->
      <div class="footer">
        <expand />
        <Button type="cancel" text="Close" @click="toggleGridLookupPopup()" />
      </div>
    </div>
  </PopupBackground>
</template>

<script>
import PopupBackground from "@/components/modals/PopupBackground";
import { mapActions, mapGetters } from "vuex";
import Button from "@/components/metrics/views/Button";

export default {
  components: {
    PopupBackground,
    Button,
  },
  data() {
    return {
      isDataAvailable: false,
      isLoading: true,
      entity_list: null,
      entity_id: null,
      entity_name: null,
    };
  },
  computed: {
    ...mapGetters("Map", ["getActiveGrid"]),
    ...mapGetters("StudioManager", ["getGeoLevel", "getConfig"]),
    mapEntityidToName() {
      if (this.entity_list && this.entity_list.length > 0) {
        return this.entity_list.map((item) => {
          return {
            ...item,
            entity_name: this.entity_name,
            entity_id: this.entity_id,
          };
        });
      }
      return [];
    },
  },
  methods: {
    ...mapActions("Popup", ["toggleGridLookupPopup"]),
    ...mapActions("Entities", ["fetchEntities"]),
    ...mapActions("LayerManager", ["createCurrentMetricPayload"]),
    ...mapActions("DataManager", ["widgetRequest"]),
    // ...mapActions("TimeManager", ["createTimeFilterpayload"]),
    ...mapActions("Time", ["createTimeFilterpayload"]),
  },
  async mounted() {
    const payloadMetric = await this.createCurrentMetricPayload();
    let payload = null;

    if (payloadMetric) {
      payload = [
        {
          widget_type: "entity_lookup",
          meta: {},
          grid_id: this.getActiveGrid,
          ...payloadMetric,
        },
      ];
    }
    const time_filters = await this.createTimeFilterpayload();

    try {
      // if it's a saved metric
      const data = await this.widgetRequest({
        payload,
        filters: {
          time_filters,
          geo_level: this.getGeoLevel,
        },
        temp: this.getConfig.isTempWidgets,
      });
      if (data && data.length > 0) {
        if (data[0] && data[0].data) {
          this.entity_list = data[0].data;
        }
      } else if (data) {
        this.entity_list = data.data;
      }

      this.entity_id = data.entity_id;
      this.entity_name = data.entity_name;
      this.isLoading = false;
      this.isDataAvailable = true;
    } catch (error) {
      console.log("Network error");
      console.error(error);
      this.isLoading = false;
      this.isDataAvailable = false;
      // this.toggleGridLookupPopup()
    }
  },
};
</script>

<style lang="scss" scoped>
.lookup-card {
  display: flex;
  flex-direction: column;
  background: var(--color-secondary);
  border-radius: 5px;
  width: 80%;
  max-width: 450px;

  .header,
  .footer {
    padding: 10px;
  }

  .header {
    padding: 20px 15px 10px 15px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid var(--border-color);

    .title {
      display: flex;
      flex-direction: column;

      h3 {
        font-weight: bold;
      }

      p {
        margin: 0;
        opacity: 0.5;
      }
    }
  }

  .contents {
    display: flex;
    flex-direction: column;

    .grid-entity-list {
      display: flex;
      flex-direction: column;
      max-height: 400px;
      border-radius: 5px;
    }

    .help-text {
      text-align: center;
    }

    .disable-events {
      pointer-events: none;
    }

    .lookup-entity-item {
      display: flex;
      flex-direction: row;
      align-items: center;
      padding: 10px;
      border-bottom: 1px solid var(--border-color);
      color: var(--font-color);

      .entity-icon {
        padding: 10px;
        background: var(--color-secondary-light);
        border-radius: 50%;
        margin-right: 15px;
      }

      label {
        font-size: 0.8em;
        pointer-events: none;
      }

      .launch-icon {
        margin-right: 15px;
      }

      &:hover {
        cursor: pointer;
        color: var(--color-primary);
        background: var(--color-primary-light);
        h4 {
          color: var(--color-primary);
        }
      }
    }
  }

  .footer {
    background-color: var(--color-default-background);
    display: flex;
    align-items: center;
    border-radius: 0 0 5px 5px;
  }
}
</style>
